"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconShows = Experimental__IconShows;
exports.IconShows = IconShows;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconShows is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconShows(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M2 2.032h12c.275 0 .51.098.706.293a.964.964 0 01.294.707v8c0 .275-.098.51-.294.706a.96.96 0 01-.706.294H2a.96.96 0 01-.706-.294.963.963 0 01-.294-.706v-8c0-.275.098-.511.294-.707A.962.962 0 012 2.032zm0 9h12v-8H2v8zm3.5 3h5c.137 0 .255.049.353.147a.48.48 0 01.147.353.481.481 0 01-.147.353.481.481 0 01-.353.147h-5a.481.481 0 01-.353-.147.481.481 0 01-.147-.353.48.48 0 01.147-.353.481.481 0 01.353-.147zm-3.5-12h12c.275 0 .51.098.706.293a.964.964 0 01.294.707v8c0 .275-.098.51-.294.706a.96.96 0 01-.706.294H2a.96.96 0 01-.706-.294.963.963 0 01-.294-.706v-8c0-.275.098-.511.294-.707A.962.962 0 012 2.032zm0 9h12v-8H2v8zm3.5 3h5c.137 0 .255.049.353.147a.48.48 0 01.147.353.481.481 0 01-.147.353.481.481 0 01-.353.147h-5a.481.481 0 01-.353-.147.481.481 0 01-.147-.353.48.48 0 01.147-.353.481.481 0 01.353-.147z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M3.75 3.794h16.5c.379 0 .702.134.97.403.27.27.405.593.405.972v11c0 .378-.135.701-.404.97a1.32 1.32 0 01-.971.405H3.75a1.32 1.32 0 01-.97-.404 1.324 1.324 0 01-.405-.971v-11c0-.379.135-.703.404-.972s.592-.403.971-.403zm0 12.375h16.5v-11H3.75v11zm4.813 4.125h6.874a.66.66 0 01.486.202.659.659 0 01.202.485.66.66 0 01-.202.486.662.662 0 01-.486.202H8.564a.662.662 0 01-.486-.202.662.662 0 01-.202-.486c0-.19.067-.351.202-.485a.662.662 0 01.486-.202zM3.75 3.794h16.5c.379 0 .702.134.97.403.27.27.405.593.405.972v11c0 .378-.135.701-.404.97a1.32 1.32 0 01-.971.405H3.75a1.32 1.32 0 01-.97-.404 1.324 1.324 0 01-.405-.971v-11c0-.379.135-.703.404-.972s.592-.403.971-.403zm0 12.375h16.5v-11H3.75v11zm4.813 4.125h6.874a.66.66 0 01.486.202.659.659 0 01.202.485.66.66 0 01-.202.486.662.662 0 01-.486.202H8.564a.662.662 0 01-.486-.202.662.662 0 01-.202-.486c0-.19.067-.351.202-.485a.662.662 0 01.486-.202z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconShows is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconShows(props) {
  return /*#__PURE__*/_react["default"].createElement(IconShows, props);
}